import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      window.addEventListener('keydown', handleEscape);
    }
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-115">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 bg-charcoal/60 backdrop-blur-sm z-40" onClick={onClose} aria-hidden="true" data-id="element-116" />
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-117">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="bg-cream rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-118">
              <div className="flex items-center justify-between p-6 border-b border-beige" data-id="element-119">
                <h2 id="modal-title" className="text-2xl md:text-3xl font-serif font-bold text-charcoal" data-id="element-120">
                  {title}
                </h2>
                <button onClick={onClose} className="p-2 hover:bg-beige rounded-full transition-colors" aria-label="Close modal" data-id="element-121">
                  <X className="w-6 h-6 text-charcoal" data-id="element-122" />
                </button>
              </div>
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-88px)]" data-id="element-123">
                {children}
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}